// @ts-nocheck
import {Container, Grid} from '@material-ui/core';
/* eslint-disable react-hooks/exhaustive-deps */
import {makeStyles} from '@material-ui/core/styles';
import {CustomButton} from 'commons/Button/CustomButton';
import LocalizedText from 'commons/LocalizedText/LocalizedText';
import BasicHeader from 'components/BasicHeader/BasicHeader';
import useFileDownload from 'hook/UseFileDownload';
import * as qs from 'query-string';
import React, {useEffect} from 'react';
import {MOBILE_BREAKPOINT} from 'utils/constants/responsive';
import Typography from '@material-ui/core/Typography';
import { FILE_ACCESS_LEVEL } from 'services/FileService';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(12)
  },
  margin: {
    padding: 20,
    margin: theme.spacing(2),
    [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
      margin: theme.spacing(1)
    }
  }
}));

export const DownloadFilePage = ({
  accessLevel = FILE_ACCESS_LEVEL.PRIVATE,
  title,
  logoutLabel,
  downloadInformation,
  downloadButtonLabel,
  downloadButtonTooltip,
  useTranslation = true
}) => {
  const classes = useStyles();
  const downloadFile = useFileDownload(accessLevel);

  const fileIdCrypted = qs.parse(window.location.search).fileId;

  useEffect(() => downloadFile(fileIdCrypted, accessLevel), []);

  const Text = useTranslation ? LocalizedText : Typography;

  return (
    <>
      <BasicHeader logoutLabel={logoutLabel} titleMobile={title} titlePC={title} useTranslation={useTranslation}/>
      <Container
        className={classes.root}
        fixed
      >
        <Grid
          alignItems="center"
          container
          direction="column"
          justifyContent="center"
        >
          <Grid item>
            <Text component="h5">{downloadInformation}</Text>
          </Grid>

          <Grid item>
            <CustomButton
              className={`${classes.margin}`}
              onClick={() => downloadFile(fileIdCrypted, accessLevel)}
              tooltip={downloadButtonTooltip}
            >
              <Text variant="inherit">{downloadButtonLabel}</Text>
            </CustomButton>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export const PrivateDownloadFilePage = () => (
  <DownloadFilePage
    accessLevel={FILE_ACCESS_LEVEL.PRIVATE}
    downloadButtonLabel="downloadFile"
    downloadButtonTooltip="downloadFileTooltip"
    downloadInformation="fileDownloadInformation"
    logoutLabel="logout"
    title="downloadFileTitle"
    useTranslation={true}/>
);

export const PublicDownloadFilePage = () => (
  <DownloadFilePage
    accessLevel={FILE_ACCESS_LEVEL.PUBLIC}
    downloadButtonLabel="Download file"
    downloadButtonTooltip="Click here to download your file"
    downloadInformation="Your file download should start shortly, if it doesn't you can click below"
    logoutLabel="Log out"
    title="Download a file"
    useTranslation={false}/>
);